import { ChipProps } from '@mui/material';
import React, { FC } from 'react';

import translate from '../../../../i18n/translate';
import MuiIcon from '../../../MUI/MuiIcon';

import * as Styled from './styled';

/**
 * Trigger for the template selection in compose modal
 *
 * @param props Props passed to the component
 *
 * @returns     Component itself
 */
const ComposeTemplateTrigger: FC<ChipProps> = props => {
  return (
    <Styled.StyledChip
      icon={<MuiIcon fontSize="small" icon="assignment" />}
      label={translate('USE__TEMPLATE')}
      variant="outlined"
      {...props}
    />
  );
};

export default ComposeTemplateTrigger;
